export default __webpack_public_path__ + "static/media/09_oplocenka.e9de10ab.jpg";